module.exports = __webpack_public_path__ + "img/more.80d746c9.svg";